import React from "react";
import { CardUi } from "../../ui/CardUi";
import { TipoButtonConstants } from "../../../types/typesConstants";
import { ButtonUi } from "../../ui/ButtonUi";
import { RutaTree } from "./RutaTree";
import { Space, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { showDeleteConfirm } from "../../../helpers/confirmModal";
import { rutaClearActive, rutaStartDelete } from "../../../actions/usuario";

export const RutaDiv = ({
  keysSelected,
  handleOpenDrawer,
  handleTreeNodeSelected,
}) => {
  const dispatch = useDispatch();
  const { activeRuta, rutasModulo } = useSelector((state) => state.usuario);
  const handleNuevaRuta = () => {
    dispatch(rutaClearActive());
    handleOpenDrawer();
  };
  const handleEliminarRuta = () => {
    showDeleteConfirm(
      "¿Está seguro de eliminar la ruta seleccionada?",
      activeRuta?.nombre,
      (isConfirmed) => {
        if (isConfirmed) {
          dispatch(rutaStartDelete(activeRuta));
        }
      }
    );
  };
  return (
    <>
      <CardUi
        title="Rutas"
        size="small"
        type="inner"
        extra={[
          <Space wrap key="opts">
            <Tooltip title="Eliminar" key="eli">
              <ButtonUi
                key="eliminar"
                typeUi={TipoButtonConstants.Eliminar}
                onClick={handleEliminarRuta}
                displayText={false}
                disabled={!activeRuta}
              />
            </Tooltip>
            <Tooltip title="Editar" key="edit">
              <ButtonUi
                key="editar"
                typeUi={TipoButtonConstants.EditarTable}
                onClick={handleOpenDrawer}
                displayText={false}
                disabled={!activeRuta}
              />
            </Tooltip>
            <ButtonUi
              key="nuevo"
              typeUi={TipoButtonConstants.Agregar}
              onClick={handleNuevaRuta}
            />
          </Space>,
        ]}
        styles={{ body: { minHeight: "400px", overflow: "auto" } }}
      >
        <RutaTree
          rutas={rutasModulo}
          keysSelected={keysSelected}
          handleTreeNodeSelected={handleTreeNodeSelected}
        />
      </CardUi>
    </>
  );
};
